/** The actual Rise login/app URL (not the marketing site) -- where Rise-covered people should go to submit or manage their time off. */
export const RISE_APP_URL = "https://platform.risepeople.com";
